module.exports = __webpack_public_path__ + "1792395595471/images/Flaticon.9b4d592.svg";